// extracted by mini-css-extract-plugin
export default {"auth_card":"style_auth_card__S2btj","auth_card__title":"style_auth_card__title__WEg28"};